var _defs, _path, _text;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHh25HowItWorksSection3IconStep3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 54.55 60.74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #f99d8f;\n      }\n\n      .cls-2 {\n        fill: #7b0051;\n        font-family: Satisfy-Regular, Satisfy;\n        font-size: 40px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M39.36,1.62c-1.88-.87-3.93-1.33-6.01-1.44C24.85-.31,15.84-.11,9.3,5.14,2.33,10.74.3,20.47.03,29.41c-.19,6.4.41,13.2,4.13,18.42,4.43,6.21,12.24,8.84,19.55,11.04,4.22,1.27,8.69,2.53,12.96,1.47,3.13-.78,5.84-2.75,8.12-5.03,7.14-7.14,10.58-17.65,9.6-27.7-.9-9.18-3.87-20.84-15.02-25.98Z"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(19.87 43.44)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "3"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHh25HowItWorksSection3IconStep3);
export default __webpack_public_path__ + "static/media/HH25_HowItWorks_Section3_IconStep3.e303b3a1f69a303efb61cd83f09dd8c1.svg";
export { ForwardRef as ReactComponent };